import React from 'react';
import clsx from 'clsx';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './DescriptionInput.css';

export const DescriptionInput = ({ data, onChange, classes }) => {
  const handleChange = (value) => {
    onChange({ target: { name: 'description', value } });
  };

  const modules = {
    toolbar: [
      [{ 'size': ['small', false, 'large'] }], 
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      /* ['link'], */
     /*  ['clean'] */
    ],
  };

  const formats = [
    'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'align', 'color', 'background', 'link', 'size' 
  ];

  return (
    <React.Fragment>
      <ReactQuill
        value={data.description}
        onChange={handleChange}
        className={clsx(classes.margin, classes.quill)}        
        theme="snow"
        modules={modules}
        formats={formats}
      />
    </React.Fragment>
  );
};
